"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CalendarCheck, CircleCheck, Truck } from "lucide-react";
const steps = [{
  num: "01",
  title: "Schedule Online/Text Photos",
  description: "Book your slot online or text us photos of your junk for a fast, transparent quote in Ottawa and Kanata. No hidden fees, just honest service."
}, {
  num: "02",
  title: "Get Transparent Quote",
  description: "Our professional team provides a firm price upon arrival at your Orleans or Nepean property. We ensure you know exactly what to expect before we start."
}, {
  num: "03",
  title: "We Handle the Heavy Lifting",
  description: "Sit back while our insured crew clears your space. We sort, donate, and recycle items at local Ottawa facilities to keep our community clean."
}];
export default function ThePathToSuccess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223571" id="how-we-clear-the-clutter" className="dark bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-5xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16 md:mb-24">
          <h2 className="text-sm/6 font-semibold text-primary font-default tracking-widest uppercase">
            Our Process
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-default">
            How We Clear the Clutter
          </p>
          <p className="mt-4 text-lg leading-8 text-muted-foreground">
            A professional, three-step approach to reclaiming your space in Kanata, Orleans, and across the Ottawa region.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="hidden md:block absolute top-8 left-[16.66%] right-[16.66%] h-[2px] border-t-2 border-dashed border-primary/30 z-0" aria-hidden="true" />

          {}
          <div className="md:hidden absolute left-8 top-8 bottom-8 w-[2px] border-l-2 border-dashed border-primary/30 z-0" aria-hidden="true" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10">
            {steps.map((step, i) => <div key={step.num} data-index={i} className="relative flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-0 group">
                {}
                <span className="absolute -top-12 md:-top-16 left-0 md:left-1/2 md:-translate-x-1/2 text-8xl font-bold text-secondary/5 pointer-events-none select-none font-default">
                  {step.num}
                </span>

                {}
                <div className="flex size-16 shrink-0 items-center justify-center rounded-lg bg-secondary text-secondary-foreground shadow-lg transition-transform duration-300 group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground">
                  {i === 0 && <CalendarCheck className="size-8" />}
                  {i === 1 && <CircleCheck className="size-8" />}
                  {i === 2 && <Truck className="size-8" />}
                </div>

                {}
                <div className="pt-3 md:pt-0 md:mt-8 md:text-center flex-1">
                  <div className="flex flex-col md:items-center">
                    <h3 className="text-lg font-bold text-foreground font-default">
                      {step.title}
                    </h3>
                    {i === 0 && <span className="mt-1 inline-block text-[10px] font-bold uppercase tracking-wider text-secondary bg-secondary/10 px-2 py-0.5 rounded-md w-fit">
                        Text Us Photos
                      </span>}
                    {i === 1 && <span className="mt-1 inline-block text-[10px] font-bold uppercase tracking-wider text-primary bg-primary/10 px-2 py-0.5 rounded-md w-fit">
                        Same-day or next-day service available
                      </span>}
                    {i === 2 && <span className="mt-1 inline-block text-[10px] font-bold uppercase tracking-wider text-primary bg-primary/10 px-2 py-0.5 rounded-md w-fit">
                        Eco-Friendly
                      </span>}
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground font-sans">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}